<template>
  <v-card-text>
    <v-text-field
      v-model="settings.sourceSettings.url"
      label="Путь для получения данных"
      hide-details
    />

    <br>

    <h3 class="mt-5">Привязка к таймлайну</h3>
    <div class="d-flex align-center">
      <v-checkbox
        v-model="settings.timelineType"
        label="Привязка к таймлайну"
      />
      <div class="ml-3">
        Для случая, когда сервер поддерживает параметры для дат. Например:
        <span class="green--text">?date={date}</span> или
        <span class="green--text">?start-date={start-date-iso}&end-date={end-date-iso}</span>
      </div>
    </div>
  </v-card-text>
</template>

<script>
export default {
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
};
</script>
